// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-menu.el-menu--horizontal[data-v-3658d101] {\n  border-bottom: none;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.el-menu--horizontal[data-v-3658d101]  .el-menu--popup {\n  padding: 0;\n}", ""]);
// Exports
module.exports = exports;
